/**
 * PostgREST devuelve como mucho 1000 filas por peticion, y no avisa: la
 * consulta responde 200, parece correcta, y simplemente faltan las demas.
 *
 * feed_items ya tiene 1173 filas publicadas, asi que las consultas que la
 * leian entera se quedaban en 1000: unos veinte posts antiguos no llegaban
 * nunca al feed ni al panel. Y lo peor no es eso, sino que el post que cae
 * justo en el corte puede quedarse con la mitad de sus fotos, porque un post
 * son varias filas.
 *
 * Esto pide pagina a pagina hasta que una venga incompleta.
 */
export const TAMANO_PAGINA = 1000;

type Respuesta<T> = { data: T[] | null; error: { message: string } | null };

export async function traerTodasLasFilas<T>(
  pagina: (desde: number, hasta: number) => PromiseLike<Respuesta<T>>,
): Promise<T[]> {
  const filas: T[] = [];
  for (let desde = 0; ; desde += TAMANO_PAGINA) {
    const { data, error } = await pagina(desde, desde + TAMANO_PAGINA - 1);
    if (error) throw error;
    const lote = data ?? [];
    filas.push(...lote);
    if (lote.length < TAMANO_PAGINA) return filas;
  }
}
